<template>
    <div>
        <!-- 打票 -->
 
        <div id="print">
          <table width="100%">
            <tr>
              <!-- <th>典当行</th> -->
              <td rowspan="2" width="8%"></td>
              <td width="12%"></td>
              <td width="33%">
                <!-- {{
                  titles == "长安典当行"
                    ? "东莞市长安典当行有限责任公司"
                    : "东莞市双庆典当有限公司"
                }} -->
                {{ $store.state.name }}
              </td>
              <td width="15%"></td>
              <td id="32%">
                <!-- {{ titles == "长安典当行" ? "0769-85323232" : "0769-81559616" }} -->
                {{ $store.state.tel }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <!-- {{
                  titles == "长安典当行"
                    ? "东莞市长安镇长青南路185号"
                    : "东莞市长安镇地王广场店"
                }} -->
                {{ $store.state.address }}
              </td>
              <td></td>
              <td>
                <!-- {{ titles == "长安典当行" ? "44014A10093" : "44282A10010" }} -->
                {{ $store.state.licence }}
              </td>
            </tr>
            <tr>
              <td rowspan="3"></td>
              <td></td>
              <td>{{ xudata.input_names }}</td>
              <td></td>
              <td>{{ xudata.input_tels }}</td>
            </tr>
            <tr>
              <td></td>
              <td>{{ xudata.input_adds }}</td>
              <td></td>
              <td>{{ xudata.input_names }}</td>
            </tr>
            <tr>
              <td></td>
              <td>{{ xudata.radios }}</td>
              <td></td>
              <td>{{ xudata.input_idcards }}</td>
            </tr>
          </table>
          <!-- 物品栏 -->

          <table width="100%">
            <tr>
              <td colspan="7"></td>
            </tr>
            <!-- <tr>
              <td colspan="7"></td>
            </tr> -->
            <tr>
              <td width="8%">1</td>
              <td width="15%">{{ xudata.tabs_inputs }}</td>
              <td width="27%">
                {{  xudata.tabs_inpus
                }}{{
                  xudata.tabs_ins !== "" && xudata.tabs_ins !== undefined
                    ? "，" + xudata.tabs_ins + "g"
                    : ""
                }}
              </td>
              <td width="5%">{{ xudata.tabs_inps }}</td>
              <td width="10%">{{ xudata.tabs_is }}</td>
              <!-- <td width="5%">{{ rate }}</td> -->
              <td width="5%">100%</td>
              <td width="26%">
                <div class="sum_pri">
                  <span v-for="item in xudata.tabs_is" :key="item.id">{{ item }}</span>
                  <span>0</span>
                  <span>0</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{ xudata.tabs_inputsa == "" || xudata.tabs_inputsa == undefined ? " ." : "2" }}
              </td>
              <td>{{ xudata.tabs_inpusa }}</td>
              <td>
                {{ xudata.tabs_inputsa
                }}{{
                  xudata.tabs_insa !== "" && xudata.tabs_insa !== undefined
                    ? "，" + xudata.tabs_insa + "g"
                    : ""
                }}
              </td>
              <td>{{ xudata.tabs_inpsa }}</td>
              <td>{{ xudata.tabs_isa }}</td>
              <td v-if="xudata.tabs_isa">100%</td>

              <td>
                <div class="sum_pri">
                  <span v-for="item in xudata.tabs_isa" :key="item.id">{{ item }}</span>
                  <span v-if="xudata.tabs_isa">0</span>
                  <span v-if="xudata.tabs_isa">0</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                {{ xudata.tabs_inputsaa == "" || xudata.tabs_inputsaa == undefined ? "." : "3" }}
              </td>
              <td>{{ xudata.tabs_inputsaa }}</td>
              <td>
                {{ xudata.tabs_inputsaa
                }}{{
                  xudata.tabs_insaa !== "" && xudata.tabs_insaa !== undefined
                    ? "，" + xudata.tabs_insaa + "g"
                    : ""
                }}
              </td>
              <td>{{ xudata.tabs_inpsaa }}</td>
              <td>{{ xudata.tabs_insaa }}</td>
              <td v-if="xudata.tabs_insaa">100%</td>
              <td>
                <div class="sum_pri">
                  <span v-for="item in xudata.tabs_isaa" :key="item.id">{{ item }}</span>
                  <span v-if="xudata.pricaa">0</span>
                  <span v-if="xudata.pricaa">0</span>
                </div>
              </td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="20%"></td>
              <td width="25%">{{ prices }}</td>
              <td width="10%"></td>
              <td width="18%"></td>
              <td width="28%">
                <div class="sum_pri">
                  <span v-for="item in xudata.tabs_is" :key="item.id">{{ item }}</span>
                  <span>0</span>
                  <span>0</span>
                </div>
              </td>
            </tr>
            <tr>
              <td width="20%"></td>
              <td width="25%">零元整（后收）</td>
              <td width="10%"></td>
              <td width="13%">0.00</td>
              <td width="28%">
                <div class="sum_pribox">
                  <span>4.2</span>
                  <span>0</span>
                </div>
              </td>
            </tr>
            <tr>
              <td width="20%"></td>
              <td width="25%"> {{prices}}</td>
              <td width="10%"></td>
              <td width="13%">{{pricesa+".00"}}</td>
              <td width="13%"></td>
              <td width="10%"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="12%"></td>
              <td width="7%">{{ n }}</td>
              <td width="5%">{{ y }}</td>
              <td width="5%">{{ r }}</td>
              <td width="7%"></td>
              <td width="7%">{{ n }}</td>
              <td width="5%">{{ y }}</td>
              <td width="5%">{{ r }}</td>
              <td width="40%"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="5%"></td>
              <td width="40%">
                当物来源（自购），当期不足5日的按5日收取利息和综合费用。如逾期绝当同意典当行自行变卖。
              </td>
              <td width="30%"></td>
            </tr>
            <tr>
              <td width="5%"></td>
              <td width="40%"></td>
              <td width="30%"></td>
            </tr>
          </table>
          <table width="100%">
            <tr>
              <td width="5%"></td>
              <td width="12%"></td>
              <td width="15%"></td>
              <td width="4%"></td>
              <td width="10%"></td>
              <td width="13%"></td>
              <td width="5%">{{ n }}</td>
              <td width="5%">{{ y }}</td>
              <td width="5%">{{ r }}</td>
              <td width="5%"></td>
            </tr>
          </table>
        </div>

        <!-- 底部按钮 -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" v-print="'#print'">确定打票</el-button>
        </div>

    </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
    name:"Printp",
    props:['xudata'],

    data() {
        return {
            prices:"",
            priceNums:"",
            pricesa:""
        }
    },
    methods: {
        //阿拉伯数字转大写

    digitUppercase(n) {
      let fraction = ["角", "分"];
      let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      let unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"],
      ];
      let head = n < 0 ? "欠" : "";
      n = Math.abs(n);
      let s = "";
      for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(
          /零./,
          ""
        );
      }
      s = s || "整";
      n = Math.floor(n);
      for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = "";
        for (let j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    },
    },
    created() {

        this.priceNums = Number(this.xudata.tabs_is)+Number(this.xudata.tabs_isa)+Number(this.xudata.tabs_isaa)
        //   this.costs = this.digitUppercase(this.xudata.tabs_is * );
    //  console.log(this.xudata)
       
        this.prices = this.digitUppercase(Number(this.xudata.tabs_is)+Number(this.xudata.tabs_isa)+Number(this.xudata.tabs_isaa));
        this.pricesa = Number(this.xudata.tabs_is)+Number(this.xudata.tabs_isa)+Number(this.xudata.tabs_isaa)

         this.n = dayjs(this.xudata.deta).year();
          this.y = dayjs(this.xudata.deta).month() + 1;
          this.r = dayjs(this.xudata.deta).date();
        

    },
}
</script>
<style scoped>
/* 打印的样式 */
#print_demo {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.cers {
  display: flex;
  flex-direction: column;
}
.cers span {
  margin: 2px 0;
  font-size: 5px;
}
.ss {
  display: flex;
  flex-direction: column;
  margin: 0 30px;
}
.ss span {
  margin: 2px 0;
  font-size: 5px;
}
.cont {
  display: flex;
  flex-direction: row;
}
.contleft {
  width: 65%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 50px;
  font-size: 5px;
}
.contrig {
  width: 35%;
  margin-top: 50px;
  font-size: 5px;
}

/* 打印样式表格 */
table {
  border-collapse: collapse;
}
th,
td {
  /* width: 100%; */
  height: 20px;
  /* border: 1px solid black; */
  font-size: 12px;
  text-align: center;
}
td input {
  outline: none;
  border: 0;
  height: 100%;
  width: 11px;
  background-color: #a5a5a5;
}
.fl {
  padding: 0 0;
}
td span input {
  background-color: #2c2c2c;
}
.ctens {
  display: flex;
  flex-direction: column;
}
.ctens span {
  margin: 12px 0;
}
.sum_pri {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.sum_pri span {
  width: 10px;
  margin: 0 5px;
}
/* .sum_pribox{
  margin: 0 5px;
} */
.sum_pribox {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.watchPiao {
  display: flex;
  flex-direction: row;
}
.upload_xg {
  margin: 0 10px;
}
.btn_xu {
  color: #2c2c2c;
  font-size: 16px;
  font-weight: bold;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>